(function () {
  // Normalize plain shade number searches (e.g. "74") to "#74" before submission
  // so Shopify's search can match product titles like "#74 - Kuiper Belt".
  function setupShadeSearch(form) {
    if (!form || form._tpShadeSearchAttached) return;
    form._tpShadeSearchAttached = true;

    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var val = input.value.trim();
      var m = val.match(/^(\d{1,3})$/); // Plain number only, no # yet
      if (!m) return;

      var n = parseInt(m[1], 10);
      if (n < 1 || n > 200) return;

      input.value = '#' + n; // Let the form submit normally with the corrected query
    });
  }

  function attachAll() {
    document.querySelectorAll('form[action*="/search"]').forEach(setupShadeSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }
})();
